import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';

const appearanceClassName = {
    red: 'tw-bg-red-500',
    blue: 'tw-bg-blue-600',
    teal: 'tw-bg-teal-500 dark:tw-bg-teal-400',
    lightBlue: 'tw-bg-blue-200 dark:tw-bg-blue-700 dark:tw-text-blue-100'
};
const sizes = {
    xs: 'tw-text-xs',
    sm: 'tw-text-sm',
    md: 'tw-text-base',
    lg: 'tw-text-lg'
};
const Badge = ({ children, overrideAppearance, appearance, dataMetrics, dataTestId, shape = 'square', size = 'sm', as: Component = 'div', textColor = 'light' }) => {
    const className = classNames('tw-font-lato tw-inline-block tw-border-none tw-m-0', textColor === 'dark' ? '' : 'tw-text-dark-bg', sizes[size], shape === 'square' && 'tw-py-1 tw-px-2 tw-rounded', shape === 'circle' &&
        (size === 'xs'
            ? 'tw-py-[1px] tw-px-1.5 tw-rounded-full'
            : size === 'sm'
                ? 'tw-py-0.5 tw-px-2 tw-rounded-full'
                : size === 'md'
                    ? 'tw-py-[3px] tw-px-2.5 tw-rounded-full'
                    : 'tw-py-1 tw-px-3 tw-rounded-full'), overrideAppearance || (appearanceClassName[appearance] && appearanceClassName[appearance]));
    return (React.createElement(Component, { "data-metrics": dataMetrics, "data-testid": dataTestId || `badge-${typeof children === 'string' && testIdGen(children)}`, className: className }, children));
};

export { Badge };
//# sourceMappingURL=Badge.esm.js.map
